export default __webpack_public_path__ + "static/media/nikhil-pawar.f8746b8d.jfif";